"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _grid = require("../../styles/grid");

var _responsive = require("../../styles/responsive");

var _breakpoints = require("../../styles/breakpoints");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Generate column breakpoint.
 */


var generateColumnBreakpoint = function generateColumnBreakpoint(breakpoint, value, offset, columns) {
  return _responsive.media.min(breakpoint)(_templateObject(), (0, _isNumber2.default)(offset) && offset >= 0 ? "margin-left: ".concat((0, _grid.columnWidth)(offset, columns), "%;") : '', (0, _isNumber2.default)(value) && value > 0 ? "width: ".concat((0, _grid.columnWidth)(value, columns), "%;") : '');
};
/**
 * Set column style.
 */


var setColumnStyles = function setColumnStyles(_ref) {
  var theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["theme"]);

  var columns = theme.grid.columns;
  var breakpointKeys = Object.keys(theme.breakpoints);
  var offsetKeys = breakpointKeys.map(function (key) {
    return "".concat(key, "Offset");
  });
  var columnProps = (0, _pick2.default)(rest, [].concat(_toConsumableArray(breakpointKeys), _toConsumableArray(offsetKeys)));
  return (0, _breakpoints.orderByBreakpoints)(columnProps, theme.breakpoints).map(function (key) {
    return generateColumnBreakpoint(key, (0, _get2.default)(columnProps, key), (0, _get2.default)(columnProps, "".concat(key, "Offset")), columns);
  });
};
/**
 * Set column padding.
 */


var setColumnPadding = function setColumnPadding(_ref2) {
  var theme = _ref2.theme;
  var _theme$grid = theme.grid,
      gutter = _theme$grid.gutter,
      unit = _theme$grid.unit;
  return (0, _styledComponents.css)(["padding-left:", "", ";padding-right:", "", ";"], gutter, unit, gutter, unit);
};
/**
 * `Col` component.
 */


var Col = _styledComponents.default.div.withConfig({
  displayName: "col__Col",
  componentId: "owywvm-0"
})(["float:left;min-height:1px;position:relative;width:100%;", " ", " ", ""], setColumnPadding, setColumnStyles, _grid.setDebugStyle);
/**
 * Export `Col` component.
 */


var _default = Col;
exports.default = _default;